import { MenuItem } from "@mui/material";

import { RoutesConstants } from "@/main/routes/routesConstants";
import { getTranslateByKey } from "@/main/services/utils";
import { useNavigate, useSearchParams } from "react-router-dom";
import { onLoadDateRangePicker } from "@/main/services/utilsDate";
import { DefaultValueParameterEnum } from "@/main/services/enum/DefaultValueParameterEnum";
import { useLocation } from "react-router-dom";

interface IThreeDotsQuoteHasOrderByClaimProps {
	hasOrderByClaim: boolean;
	claimNumber: string;
}
function ThreeDotsQuoteHasOrderByClaim({ claimNumber, hasOrderByClaim }: IThreeDotsQuoteHasOrderByClaimProps) {
	const navigate = useNavigate();
	const location = useLocation();
	const [_, setSearchParams] = useSearchParams();

	function handleClick() {
		const { firstDateResult, secondDateResult } = onLoadDateRangePicker(DefaultValueParameterEnum.FallbackRangeDate);
		const firstDateFormatted = firstDateResult.toISOString();
		const secondDateFormatted = secondDateResult.toISOString();
		const hasOrderScreen = location.pathname === RoutesConstants.orderSearchOrder;

		if (hasOrderScreen) {
			const requestSearchParams = {
				quoteFilterVehicle: claimNumber,
				startDate: firstDateFormatted,
				finalDate: secondDateFormatted,
			};
			setSearchParams(requestSearchParams, { replace: true });
			return;
		}

		const urlRedirect = `${RoutesConstants.orderSearchOrder}?quoteFilterVehicle=${claimNumber}&startDate=${firstDateFormatted}&finalDate=${secondDateFormatted}`;
		navigate(urlRedirect);
	}

	if (!hasOrderByClaim) return null;
	return (
		<MenuItem id="id-createOrder-button-see-orders-by-claim" onClick={handleClick}>
			{getTranslateByKey("information.seeOrderByClaim")}
		</MenuItem>
	);
}

export { ThreeDotsQuoteHasOrderByClaim };
